import React from "react";
import { FormInscription } from "../components/FormInscription/FormInscription";
import { NavBar } from "../components/NavBar/NavBar";

export function Home() {
	return (
		<div>
			<NavBar />
			<FormInscription />
			<footer
				className="bg-dark text-center mb-0 p-3"
				style={{ marginTop: "200px" }}
			>
				<p className="text-white">
					© 2021 Municipalidad de San Nicolás de los Arroyos
				</p>
			</footer>
		</div>
	);
}
